import { useLocation } from 'react-router-dom';
import { InvestorTopBar } from '../components/layout/investor/InvestorTopBar';
import { InvestorIconRail } from '../components/layout/investor/InvestorIconRail';
import { titleForPath } from '../routes/pathTitles';
import { WorkspaceGate } from './WorkspaceGate';

function cleanTitle(title) {
  return title.replace(/^(?:eVault\s+)?Investor(?:\s+workspace)?\s*[—-]\s*/i, '');
}

export function InvestorShell() {
  const { pathname } = useLocation();
  const { title, subtitle } = titleForPath(pathname);

  return (
    <div className="flex h-screen flex-col bg-eorig-surface pt-3 font-sans text-sm text-eorig-ink">
      <InvestorTopBar />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <InvestorIconRail />
        <main className="min-w-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-7xl">
            <WorkspaceGate title={cleanTitle(title)} subtitle={subtitle} />
          </div>
        </main>
      </div>
    </div>
  );
}
